import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_STORAGE_KEY || "rh_fallback_key_2024";

const hashKey = (key) =>
  CryptoJS.HmacSHA256(key, SECRET_KEY).toString().substring(0, 32);

const encrypt = (value) => {
  if (value === null || value === undefined) return null;
  return CryptoJS.AES.encrypt(String(value), SECRET_KEY).toString();
};

const decrypt = (cipher) => {
  if (!cipher) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    const result = bytes.toString(CryptoJS.enc.Utf8);
    return result || null;
  } catch {
    return null;
  }
};

const secureStorage = {
  setItem: (key, value) => {
    localStorage.setItem(hashKey(key), encrypt(value));
  },
  getItem: (key) => {
    return decrypt(localStorage.getItem(hashKey(key)));
  },
  removeItem: (key) => {
    localStorage.removeItem(hashKey(key));
  },
  clear: () => {
    localStorage.clear();
  },
};

export default secureStorage;
